import { supabase } from '../config/supabase'
import { applySalonFilter, preferLocationRows } from '../utils/salonScope'

/**
 * Fetch all service categories
 */
export const getCategories = async () => {
  try {
    let query = supabase
      .from('service_categories')
      .select('*')
    query = applySalonFilter(query, { includeBrandWide: true })
    const { data, error } = await query.order('sort_order', { ascending: true })

    if (error) throw error
    return { data: preferLocationRows(data), error: null }
  } catch (error) {
    console.error('Error fetching categories:', error)
    return { data: null, error }
  }
}

/**
 * Fetch a single category by ID
 */
export const getCategoryById = async (id) => {
  try {
    const { data, error } = await supabase
      .from('service_categories')
      .select('*')
      .eq('id', id)
      .single()

    if (error) throw error
    return { data, error: null }
  } catch (error) {
    console.error('Error fetching category:', error)
    return { data: null, error }
  }
}

/**
 * Create a new category
 */
export const createCategory = async (categoryData) => {
  try {
    const { getSelectedSalonId } = await import('../utils/salonScope')
    const payload = {
      ...categoryData,
      salon_id: categoryData.salon_id || getSelectedSalonId() || null,
    }
    const { data, error } = await supabase
      .from('service_categories')
      .insert([payload])
      .select()
      .single()

    if (error) throw error
    return { data, error: null }
  } catch (error) {
    console.error('Error creating category:', error)
    return { data: null, error }
  }
}

/**
 * Update a category
 */
export const updateCategory = async (id, updates) => {
  try {
    const { data, error } = await supabase
      .from('service_categories')
      .update(updates)
      .eq('id', id)
      .select()
      .single()

    if (error) throw error
    return { data, error: null }
  } catch (error) {
    console.error('Error updating category:', error)
    return { data: null, error }
  }
}

/**
 * Delete a category
 */
export const deleteCategory = async (id) => {
  try {
    const { error } = await supabase
      .from('service_categories')
      .delete()
      .eq('id', id)

    if (error) throw error
    return { error: null }
  } catch (error) {
    console.error('Error deleting category:', error)
    return { error }
  }
}
